@let widgetName =
  widgetsEc.plugins.currentEntityPlugin.feature.selectors
    .getLatestEntity()
    .asSignal()?.name;
@let isSubmitting =
  widgetsEc.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal();
@let submissionErrorMessage =
  widgetsEc.plugins.editingPlugin.feature.selectors.submissionError.asSignal();
@let breadcrumbs = breadcrumbsSg();
@let isLoading = isLoadingSg();

<atn-ds-page class="atn-mosaic-dev-widget-builder">
  <atn-ds-page-header
    pageHeader
    [name]="widgetName"
    [breadcrumbs]="breadcrumbs"
  >
    <div
      class="atn-mosaic-dev-widget-builder__actions"
      actions
    >
      <div class="atn-mosaic-dev-widget-builder__error">
        {{ submissionErrorMessage }}
      </div>
      <atn-ds-button
        [isIcon]="true"
        [loading]="isSubmitting"
        type="white"
        (click)="saveButtonClickHandler()"
      >
        <i class="atn-icon atn-save atn-blue"></i>
      </atn-ds-button>
    </div>
  </atn-ds-page-header>

  @if (isLoading) {
    <atn-ds-loader type="page" />
  } @else {
    <div class="atn-mosaic-dev-widget-builder__content">
      <atn-ds-integrated-horizontal-tabs
        class="atn-mosaic-dev-widget-builder__tabs"
      >
        <ng-template
          atnDsTab
          name="Query"
        >
          <atn-widget-builder-query-tab />
        </ng-template>
        <ng-template
          atnDsTab
          name="General"
        >
          <atn-widget-builder-general-tab />
        </ng-template>
      </atn-ds-integrated-horizontal-tabs>
    </div>
  }
</atn-ds-page>
